export function sanitizeUrl(
  isInsider: boolean,
  originalUrl: string,
  origin: string = window.location.origin
): string {
  if (isInsider) {
    if (!originalUrl.includes('.com')) return '#'
    const [, pathAfterCom] = originalUrl.split('.com')
    return `${origin}${pathAfterCom}`
  }

  return `${origin}/${originalUrl}/p`
}
